var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "page" }, [
    _c(
      "div",
      { staticClass: "subpage" },
      [
        _vm.gridImageArr && _vm.gridImageArr.length > 0
          ? [
              _vm._l(_vm.gridImageArr, function(grid, index) {
                return [
                  _c(
                    "div",
                    { key: index, staticClass: "row" },
                    [
                      _vm._l(grid, function(gridTemp, indexTemp) {
                        return [
                          _c("div", { key: "div-img " + indexTemp }, [
                            _c("img", { attrs: { src: gridTemp.doc } }),
                            _vm._v(" "),
                            _c("label", [_vm._v("Part No.")]),
                            _vm._v(" "),
                            _c("label", [
                              _vm._v(_vm._s(gridTemp.strip_part_no))
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "vvg-water-mark",
                              attrs: { src: "/static/images/placeholder.png" }
                            })
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ]
              })
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0ae15d2f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ae15d2f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inventory/GridQRCodeImages.vue
// module id = null
// module chunks = 